"use client";

import Link from "next/link";
import { useEffect, useRef } from "react";

export default function InfraCTA() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("visible");
        });
      },
      { threshold: 0.2 }
    );
    ref?.current?.querySelectorAll(".reveal")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 bg-[#11161D]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="reveal">
          <div className="tag-badge mx-auto mb-6 inline-flex">Access Infrastructure</div>
          <h2 className="section-title text-[#F0F4F8] mb-6">
            Ready to <span className="text-[#00E676]">Deploy?</span>
          </h2>
          <p className="text-[#6B7A8D] text-base leading-relaxed mb-10 max-w-xl mx-auto">
            Initiate your infrastructure review. Onboarding is controlled to
            maintain performance standards across the network.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href="/contact"
              className="btn-solid-glow px-10 py-4 rounded-full text-sm font-bold uppercase tracking-[0.1em] inline-block"
            >
              Initiate Infrastructure Review →
            </Link>
            <Link
              href="/pricing"
              className="btn-glow px-10 py-4 rounded-full text-sm font-bold uppercase tracking-[0.1em] inline-block"
            >
              View Pricing
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}